export enum AreaComumDia {
  Segunda = "segunda",
  Terca = "terca",
  Quarta = "quarta",
  Quinta = "quinta",
  Sexta = "sexta",
  Feriado = "feriado",
  Sabado = "sabado",
  Domingo = "domingo",
  DiaAntesFeriado = "1-dia-antes-feriado",
  DiaDepoisFeriado = "1-dia-depois-feriado",
}

export enum FormaValorTaxa {
  ValorFixo = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  ValorVariavel = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
}
